import { EventsDashboard } from "../features/calendar/pages/calendarPage"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function KeyEventsPage() {
  return (
    <DashboardLayout>
      <EventsDashboard />
    </DashboardLayout>
  )
}
